/* global FS */
/* eslint camelcase: "off", dot-notation: "off" */

function lazyLoadScript(src, id) {
  if (!document.getElementById(id)) {
    const fjs = document.getElementsByTagName('script')[0];
    const js = document.createElement('script');
    js.id = id;
    js.src = src;
    fjs.parentNode.insertBefore(js, fjs);
  }
}

function getCookieValue(name) {
  return (document.cookie.match(`${name}=([^;]*)`) || ['']).pop();
}

function prepareFullstoryPlaceholder() {
  const g = window.FS = (a, b) => g.q ? g.q.push([a, b]) : g._api(a, b);
  FS.setUserVars = v => v && g('user', v);
  FS.identify = (i, v) => {
    g('user', {uid: i});
    g.setUserVars(v);
  };
  FS.q = [];
}

function configFullstoryGlobals(options, iframe) {
  window._fs_debug = false;
  window._fs_host = options.host || 'www.fullstory.com';
  window._fs_org = options.org || '1zuo';
  if (iframe) {
    window._fs_run_in_iframe = true;
  } else if (window !== window.top) {
    window._fs_is_outer_script = true;
  }
}

function identifyFullstory(options) {
  const wixClient = getCookieValue('wixClient').split('|');
  const userId = wixClient[6] || getCookieValue('_wixCIDX');
  const userDetails = {label_str: options.label, labels_str: options.label};
  if (wixClient[0]) {
    userDetails.displayName = wixClient[0];
    try {
      userDetails.email = JSON.parse(localStorage[`userID-${userId}`]).details.email;
    } catch (e) {}
  } else {
    userDetails.prevUserId_str = getCookieValue('_wixUIDX').split('|').pop();
  }
  FS.identify(userId, userDetails);
}

function boolToPromise(bool) {
  return Promise.resolve(bool).then(bool => bool ? Promise.resolve(bool) : Promise.reject(bool));
}

function httpRequest(url) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'text';
    xhr.onload = () => resolve(xhr.responseText);
    xhr.onerror = () => reject(`Failed to load ${url}`);
    xhr.send();
  });
}

function conductExperiment(name) {
  const conductUrl = '/_api/wix-laboratory-server/laboratory/conductExperiment';
  return httpRequest(`${conductUrl}?key=${name}&fallback=false`, {credentials: 'same-origin'})
    .then(x => x === 'true' || x === 'new');
}

function invertPromise(p) {
  return new Promise((resolve, reject) => Promise.resolve(p).then(reject).catch(resolve));
}

function somePromise(arr) {
  return invertPromise(Promise.all(arr.map(invertPromise)));
}

function checkSample(options) {
  const mustRecord = window.location.toString().indexOf('alwaysfs') !== -1 ||
    (options.sample !== undefined && Math.random() < options.sample);
  const conditions = [
    options.spec && conductExperiment(options.spec),
    options.sample === undefined && conductExperiment('specs.FullStoryGlobal')
  ].filter(x => x);

  if (mustRecord) {
    return Promise.resolve();
  } else {
    return somePromise(conditions.map(boolToPromise));
  }
}

function initiateContainerPingListener(options, iframe) {
  const labels = [options.label];
  window.addEventListener('message', e => {
    const [command, label] = (typeof e.data === 'string' ? e.data : '').split('|');
    if (command === 'WIX_FULLSORY_PING') {
      if (iframe) {
        window.parent.postMessage(e.data, '*');
      } else {
        labels.push(label);
        FS.setUserVars({labels_str: labels.join(',')});
      }
      e.source.postMessage('WIX_FULLSORY_PONG', e.origin);
    }
  });
}

function loadFullstory(options, iframe) {
  initiateContainerPingListener(options, iframe);
  prepareFullstoryPlaceholder();
  configFullstoryGlobals(options, iframe);
  lazyLoadScript(`//${window._fs_host}/s/fs.js`, 'fs-jstag');
}

function reportWhenSessionReady(options) {
  if (options.onReady) {
    window._fs_ready = () => {
      options.onReady(FS.getCurrentSessionURL());
    };
  }
}

function isContainerRecording(options) {
  return new Promise(resolve => {
    const timeout = setTimeout(() => resolve(false), 100);
    window.addEventListener('message', e => {
      if (e.data === 'WIX_FULLSORY_PONG') {
        clearTimeout(timeout);
        resolve(true);
      }
    });
    window.parent.postMessage(`WIX_FULLSORY_PING|${options.label}`, '*');
  });
}

module.exports = async options => {
  if (window !== window.top && await isContainerRecording(options)) {
    loadFullstory(options, true);
  } else {
    checkSample(options).then(() => {
      reportWhenSessionReady(options);
      loadFullstory(options, false);
      identifyFullstory(options);
    }).catch(() => undefined);
  }
};



// WEBPACK FOOTER //
// ./app.js